export * from "./buy-cloud-post-order-provisioning-page.template";
export { BuyCloudPostOrderProvisioningPageTemplate as default } from "./buy-cloud-post-order-provisioning-page.template";
